import script from "./feeStandards.vue?vue&type=script&lang=ts&setup=true"
export * from "./feeStandards.vue?vue&type=script&lang=ts&setup=true"

import "./feeStandards.vue?vue&type=style&index=0&id=373c5cf5&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-373c5cf5"]])

export default __exports__